module.exports = __webpack_public_path__ + "static/media/DeathCard_Bookcover.1be20a2f.jpg";